<template>
  <div class="og-fixed" :style="position" v-if="homeValue.scrollTop>=scrollTop">
    <slot name="fixedWrapper"/>
  </div>
</template>

<script>
export default {
  name: "Fixed",
  props:{
    position:{
      type: Object,
      default:()=>{}
    },
    scrollTop:{
      type: Number,
      default: 100
    }
  },
  inject:['homeValue']
}
</script>

<style scoped>
.og-fixed{
  position: fixed;
  top: 60px;
  right: 40px;
  z-index: 1000;
}
@media (max-width: 768px) {
  .og-fixed{
    right: 20px;
    padding: 10px;
    background: #FFFFFF;
    text-align: center;
    border: 1px solid #eee;
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Fixed.vue